import { render } from "./GroupHRFrame.vue?vue&type=template&id=ccb7ea38&scoped=true"
import script from "./GroupHRFrame.vue?vue&type=script&lang=js"
export * from "./GroupHRFrame.vue?vue&type=script&lang=js"

import "./GroupHRFrame.vue?vue&type=style&index=0&id=ccb7ea38&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\hr\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccb7ea38"]])

export default __exports__